module.exports = "//public.getcloudapp.com/packs/media/images/icons-download-solid-dca92f9329c42e792f055704dfde9fa9.svg";